// @import

import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addDotBtnsAndClickHandlers } from "@src/js/lib/slider";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";

Alpine.directive("pushs-colored", (element, {}, { cleanup, effect }) => {
  const dom = {
    viewport: ensureHTMLElement(element.querySelector(".c-pushs-colored__slider-viewport")),
    pagination: element.querySelector<HTMLElement>(".c-slider-pagination"),
  };

  let slider: ReturnType<typeof EmblaCarousel> | null = null;

  effect(() => {
    if (viewport.width < 1024) {
      initSlider();
    } else {
      destroySlider();
    }
  });

  function destroySlider() {
    if (slider) {
      slider.destroy();
      slider = null;
    }
  }

  function initSlider() {
    if (!slider) {
      slider = EmblaCarousel(dom.viewport, { align: "start" });
      const removePagination = addDotBtnsAndClickHandlers(slider, { dotsNode: dom.pagination });
      slider.on("destroy", removePagination);
    }
  }

  cleanup(() => {
    destroySlider();
  });
});
